export default "__VITE_ASSET__BqD7fKZ3__"